export const SET_FEEDBACK_FORM_DATA = "SET_FEEDBACK_FORM_DATA";
export const SET_TICKET_FEEDBACK = "SET_TICKET_FEEDBACK";
